import React, { useState } from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import Icon from "@components/icon";
import Tooltip from "@components/tooltip";

import StarsLink from "../../../StarsLink";

import copyTextToClipboard from "../../../../utils/copyToClipboard";

import { sendNavigationMetric } from "../../../../utils/sendMetric";
import { useStore } from "../../../../connect";

import strings from "../../../../locales/strings";

import styles from "./ProfileFirmInfo.scss";

const cx = classnames.bind(styles);

const ProfileFirmInfo = () => {
  const { profile, baseUrl } = useStore();
  const [showCopiedTooltip, setShowTooltip] = useState(false);

  const copyCode = () => {
    copyTextToClipboard(profile.user.ati_code);

    if (!showCopiedTooltip) {
      setShowTooltip(true);

      setTimeout(() => {
        setShowTooltip(false);
      }, 1000);
    } else {
      setShowTooltip(false);
    }
  };

  return (
    <div className={cx("profile-firm-info")}>
      <StarsLink
        atiCode={profile.user.ati_code}
        className={cx("profile-stars")}
        baseUrl={baseUrl}
        onClick={() => {
          sendNavigationMetric("PROFILE_STARS");
        }}
      />
      <span className={cx("profile-firm-name")}>{profile.user.firm_name}</span>
      {profile.user.ati_code && (
        <Tooltip
          visible={showCopiedTooltip}
          content={strings.submenu_codeCopied}
          isWithoutWrapper
          disabled={!showCopiedTooltip}
        >
          <button className={cx("profile-code")} onClick={copyCode}>
            <span className={cx("profile-code-text")}>
              {strings.profile_code}: {profile.user.ati_code}
            </span>
            <Icon
              name="ic_copy-out"
              size="s"
              color="var(--glz-color-neutral-tone-5)"
            />
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default observer(ProfileFirmInfo);
